function hirePage() {
    return(
        <div styles={{backgroundColor:"blue", }}>Hello</div>
    )
}

export default hirePage